import React from "react";

const KnowledgeConfigContext = React.createContext({
  knowledgeConfig: "",
  setKnowledgeConfig: () => {},
}); // default value is 'light'

export default KnowledgeConfigContext;
